import SimpleSchema from '@boilerplate/lib/simpleSchema';
import { getI18n } from 'react-i18next';

const schema = new SimpleSchema({
        id: {
          type: String,
          optional: true,
          form: false,
          view: true,
        },
        name: {
          type: String,
          form: true,
          view: true,
        },
        timeZone: {
          type: String,
          defaultValue: "Europe/Amsterdam",
          form: {
            component: 'Select',
          },
          view: true,
          allowedValues: [
            'Africa/Abidjan',
            'Africa/Accra',
            'Africa/Addis_Ababa',
            'Africa/Algiers',
            'Africa/Asmera',
            'Africa/Bamako',
            'Africa/Bangui',
            'Africa/Banjul',
            'Africa/Bissau',
            'Africa/Blantyre',
            'Africa/Brazzaville',
            'Africa/Bujumbura',
            'Africa/Cairo',
            'Africa/Casablanca',
            'Africa/Ceuta',
            'Africa/Conakry',
            'Africa/Dakar',
            'Africa/Dar_es_Salaam',
            'Africa/Djibouti',
            'Africa/Douala',
            'Africa/El_Aaiun',
            'Africa/Freetown',
            'Africa/Gaborone',
            'Africa/Harare',
            'Africa/Johannesburg',
            'Africa/Juba',
            'Africa/Kampala',
            'Africa/Khartoum',
            'Africa/Kigali',
            'Africa/Kinshasa',
            'Africa/Lagos',
            'Africa/Libreville',
            'Africa/Lome',
            'Africa/Luanda',
            'Africa/Lubumbashi',
            'Africa/Lusaka',
            'Africa/Malabo',
            'Africa/Maputo',
            'Africa/Maseru',
            'Africa/Mbabane',
            'Africa/Mogadishu',
            'Africa/Monrovia',
            'Africa/Nairobi',
            'Africa/Ndjamena',
            'Africa/Niamey',
            'Africa/Nouakchott',
            'Africa/Ouagadougou',
            'Africa/Porto-Novo',
            'Africa/Sao_Tome',
            'Africa/Tripoli',
            'Africa/Tunis',
            'Africa/Windhoek',
            'America/Adak',
            'America/Anchorage',
            'America/Anguilla',
            'America/Antigua',
            'America/Araguaina',
            'America/Argentina/La_Rioja',
            'America/Argentina/Rio_Gallegos',
            'America/Argentina/Salta',
            'America/Argentina/San_Juan',
            'America/Argentina/San_Luis',
            'America/Argentina/Tucuman',
            'America/Argentina/Ushuaia',
            'America/Aruba',
            'America/Asuncion',
            'America/Bahia',
            'America/Bahia_Banderas',
            'America/Barbados',
            'America/Belem',
            'America/Belize',
            'America/Blanc-Sablon',
            'America/Boa_Vista',
            'America/Bogota',
            'America/Boise',
            'America/Buenos_Aires',
            'America/Cambridge_Bay',
            'America/Campo_Grande',
            'America/Cancun',
            'America/Caracas',
            'America/Catamarca',
            'America/Cayenne',
            'America/Cayman',
            'America/Chicago',
            'America/Chihuahua',
            'America/Ciudad_Juarez',
            'America/Coral_Harbour',
            'America/Cordoba',
            'America/Costa_Rica',
            'America/Coyhaique',
            'America/Creston',
            'America/Cuiaba',
            'America/Curacao',
            'America/Danmarkshavn',
            'America/Dawson',
            'America/Dawson_Creek',
            'America/Denver',
            'America/Detroit',
            'America/Dominica',
            'America/Edmonton',
            'America/Eirunepe',
            'America/El_Salvador',
            'America/Fort_Nelson',
            'America/Fortaleza',
            'America/Glace_Bay',
            'America/Godthab',
            'America/Goose_Bay',
            'America/Grand_Turk',
            'America/Grenada',
            'America/Guadeloupe',
            'America/Guatemala',
            'America/Guayaquil',
            'America/Guyana',
            'America/Halifax',
            'America/Havana',
            'America/Hermosillo',
            'America/Indiana/Knox',
            'America/Indiana/Marengo',
            'America/Indiana/Petersburg',
            'America/Indiana/Tell_City',
            'America/Indiana/Vevay',
            'America/Indiana/Vincennes',
            'America/Indiana/Winamac',
            'America/Indianapolis',
            'America/Inuvik',
            'America/Iqaluit',
            'America/Jamaica',
            'America/Jujuy',
            'America/Juneau',
            'America/Kentucky/Monticello',
            'America/Kralendijk',
            'America/La_Paz',
            'America/Lima',
            'America/Los_Angeles',
            'America/Louisville',
            'America/Lower_Princes',
            'America/Maceio',
            'America/Managua',
            'America/Manaus',
            'America/Marigot',
            'America/Martinique',
            'America/Matamoros',
            'America/Mazatlan',
            'America/Mendoza',
            'America/Menominee',
            'America/Merida',
            'America/Metlakatla',
            'America/Mexico_City',
            'America/Miquelon',
            'America/Moncton',
            'America/Monterrey',
            'America/Montevideo',
            'America/Montserrat',
            'America/Nassau',
            'America/New_York',
            'America/Nome',
            'America/Noronha',
            'America/North_Dakota/Beulah',
            'America/North_Dakota/Center',
            'America/North_Dakota/New_Salem',
            'America/Ojinaga',
            'America/Panama',
            'America/Paramaribo',
            'America/Phoenix',
            'America/Port-au-Prince',
            'America/Port_of_Spain',
            'America/Porto_Velho',
            'America/Puerto_Rico',
            'America/Punta_Arenas',
            'America/Rankin_Inlet',
            'America/Recife',
            'America/Regina',
            'America/Resolute',
            'America/Rio_Branco',
            'America/Santarem',
            'America/Santiago',
            'America/Santo_Domingo',
            'America/Sao_Paulo',
            'America/Scoresbysund',
            'America/Sitka',
            'America/St_Barthelemy',
            'America/St_Johns',
            'America/St_Kitts',
            'America/St_Lucia',
            'America/St_Thomas',
            'America/St_Vincent',
            'America/Swift_Current',
            'America/Tegucigalpa',
            'America/Thule',
            'America/Tijuana',
            'America/Toronto',
            'America/Tortola',
            'America/Vancouver',
            'America/Whitehorse',
            'America/Winnipeg',
            'America/Yakutat',
            'Antarctica/Casey',
            'Antarctica/Davis',
            'Antarctica/DumontDUrville',
            'Antarctica/Macquarie',
            'Antarctica/Mawson',
            'Antarctica/McMurdo',
            'Antarctica/Palmer',
            'Antarctica/Rothera',
            'Antarctica/Syowa',
            'Antarctica/Troll',
            'Antarctica/Vostok',
            'Arctic/Longyearbyen',
            'Asia/Aden',
            'Asia/Almaty',
            'Asia/Amman',
            'Asia/Anadyr',
            'Asia/Aqtau',
            'Asia/Aqtobe',
            'Asia/Ashgabat',
            'Asia/Atyrau',
            'Asia/Baghdad',
            'Asia/Bahrain',
            'Asia/Baku',
            'Asia/Bangkok',
            'Asia/Barnaul',
            'Asia/Beirut',
            'Asia/Bishkek',
            'Asia/Brunei',
            'Asia/Calcutta',
            'Asia/Chita',
            'Asia/Colombo',
            'Asia/Damascus',
            'Asia/Dhaka',
            'Asia/Dili',
            'Asia/Dubai',
            'Asia/Dushanbe',
            'Asia/Famagusta',
            'Asia/Gaza',
            'Asia/Hebron',
            'Asia/Hong_Kong',
            'Asia/Hovd',
            'Asia/Irkutsk',
            'Asia/Jakarta',
            'Asia/Jayapura',
            'Asia/Jerusalem',
            'Asia/Kabul',
            'Asia/Kamchatka',
            'Asia/Karachi',
            'Asia/Katmandu',
            'Asia/Khandyga',
            'Asia/Krasnoyarsk',
            'Asia/Kuala_Lumpur',
            'Asia/Kuching',
            'Asia/Kuwait',
            'Asia/Macau',
            'Asia/Magadan',
            'Asia/Makassar',
            'Asia/Manila',
            'Asia/Muscat',
            'Asia/Nicosia',
            'Asia/Novokuznetsk',
            'Asia/Novosibirsk',
            'Asia/Omsk',
            'Asia/Oral',
            'Asia/Phnom_Penh',
            'Asia/Pontianak',
            'Asia/Pyongyang',
            'Asia/Qatar',
            'Asia/Qostanay',
            'Asia/Qyzylorda',
            'Asia/Rangoon',
            'Asia/Riyadh',
            'Asia/Saigon',
            'Asia/Sakhalin',
            'Asia/Samarkand',
            'Asia/Seoul',
            'Asia/Shanghai',
            'Asia/Singapore',
            'Asia/Srednekolymsk',
            'Asia/Taipei',
            'Asia/Tashkent',
            'Asia/Tbilisi',
            'Asia/Tehran',
            'Asia/Thimphu',
            'Asia/Tokyo',
            'Asia/Tomsk',
            'Asia/Ulaanbaatar',
            'Asia/Urumqi',
            'Asia/Ust-Nera',
            'Asia/Vientiane',
            'Asia/Vladivostok',
            'Asia/Yakutsk',
            'Asia/Yekaterinburg',
            'Asia/Yerevan',
            'Atlantic/Azores',
            'Atlantic/Bermuda',
            'Atlantic/Canary',
            'Atlantic/Cape_Verde',
            'Atlantic/Faeroe',
            'Atlantic/Madeira',
            'Atlantic/Reykjavik',
            'Atlantic/South_Georgia',
            'Atlantic/St_Helena',
            'Atlantic/Stanley',
            'Australia/Adelaide',
            'Australia/Brisbane',
            'Australia/Broken_Hill',
            'Australia/Darwin',
            'Australia/Eucla',
            'Australia/Hobart',
            'Australia/Lindeman',
            'Australia/Lord_Howe',
            'Australia/Melbourne',
            'Australia/Perth',
            'Australia/Sydney',
            'Europe/Amsterdam',
            'Europe/Andorra',
            'Europe/Astrakhan',
            'Europe/Athens',
            'Europe/Belgrade',
            'Europe/Berlin',
            'Europe/Bratislava',
            'Europe/Brussels',
            'Europe/Bucharest',
            'Europe/Budapest',
            'Europe/Busingen',
            'Europe/Chisinau',
            'Europe/Copenhagen',
            'Europe/Dublin',
            'Europe/Gibraltar',
            'Europe/Guernsey',
            'Europe/Helsinki',
            'Europe/Isle_of_Man',
            'Europe/Istanbul',
            'Europe/Jersey',
            'Europe/Kaliningrad',
            'Europe/Kiev',
            'Europe/Kirov',
            'Europe/Lisbon',
            'Europe/Ljubljana',
            'Europe/London',
            'Europe/Luxembourg',
            'Europe/Madrid',
            'Europe/Malta',
            'Europe/Mariehamn',
            'Europe/Minsk',
            'Europe/Monaco',
            'Europe/Moscow',
            'Europe/Oslo',
            'Europe/Paris',
            'Europe/Podgorica',
            'Europe/Prague',
            'Europe/Riga',
            'Europe/Rome',
            'Europe/Samara',
            'Europe/San_Marino',
            'Europe/Sarajevo',
            'Europe/Saratov',
            'Europe/Simferopol',
            'Europe/Skopje',
            'Europe/Sofia',
            'Europe/Stockholm',
            'Europe/Tallinn',
            'Europe/Tirane',
            'Europe/Ulyanovsk',
            'Europe/Vaduz',
            'Europe/Vatican',
            'Europe/Vienna',
            'Europe/Vilnius',
            'Europe/Volgograd',
            'Europe/Warsaw',
            'Europe/Zagreb',
            'Europe/Zurich',
            'Indian/Antananarivo',
            'Indian/Chagos',
            'Indian/Christmas',
            'Indian/Cocos',
            'Indian/Comoro',
            'Indian/Kerguelen',
            'Indian/Mahe',
            'Indian/Maldives',
            'Indian/Mauritius',
            'Indian/Mayotte',
            'Indian/Reunion',
            'Pacific/Apia',
            'Pacific/Auckland',
            'Pacific/Bougainville',
            'Pacific/Chatham',
            'Pacific/Easter',
            'Pacific/Efate',
            'Pacific/Enderbury',
            'Pacific/Fakaofo',
            'Pacific/Fiji',
            'Pacific/Funafuti',
            'Pacific/Galapagos',
            'Pacific/Gambier',
            'Pacific/Guadalcanal',
            'Pacific/Guam',
            'Pacific/Honolulu',
            'Pacific/Kiritimati',
            'Pacific/Kosrae',
            'Pacific/Kwajalein',
            'Pacific/Majuro',
            'Pacific/Marquesas',
            'Pacific/Midway',
            'Pacific/Nauru',
            'Pacific/Niue',
            'Pacific/Norfolk',
            'Pacific/Noumea',
            'Pacific/Pago_Pago',
            'Pacific/Palau',
            'Pacific/Pitcairn',
            'Pacific/Ponape',
            'Pacific/Port_Moresby',
            'Pacific/Rarotonga',
            'Pacific/Saipan',
            'Pacific/Tahiti',
            'Pacific/Tarawa',
            'Pacific/Tongatapu',
            'Pacific/Truk',
            'Pacific/Wake',
            'Pacific/Wallis',
          ],
        },
        userTenantRoles: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'userTenantRole',
            displayField: 'id',
          },
          optional: true,
          form: false,
          view: true,
        },
        'userTenantRoles.$': {
          type: String,
          optional: true,
        },
        publicKey: {
          type: String,
          form: false,
          view: true,
        },
        privateKey: {
          type: String,
          form: false,
          view: true,
        },
        redirectUri: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        termsAndConditions: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        frontendBaseUri: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        googleAuthEnabled: {
          type: Boolean,
          defaultValue: false,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        googleId: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        googleSecret: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        microsoftAuthEnabled: {
          type: Boolean,
          defaultValue: false,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        microsoftId: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        microsoftSecret: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        microsoftTenantId: {
          type: String,
          optional: true,
          form: true,
          view: true,
        },
        inviteExpiration: {
          type: SimpleSchema.Integer,
          defaultValue: 1209600000,
          form: {
            component: 'Number',
          },
          view: true,
        },
        passwordResetExpiration: {
          type: SimpleSchema.Integer,
          defaultValue: 10800000,
          form: {
            component: 'Number',
          },
          view: true,
        },
        registerEnabled: {
          type: Boolean,
          defaultValue: false,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        confirmAccountEnabled: {
          type: Boolean,
          defaultValue: true,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        contents: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'content',
            displayField: 'name',
          },
          optional: true,
          form: false,
          view: true,
        },
        'contents.$': {
          type: String,
          optional: true,
        },
        allowedApiHostnames: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'allowedApiHostname',
            displayField: 'id',
          },
          optional: true,
          form: false,
          view: true,
        },
        'allowedApiHostnames.$': {
          type: String,
          optional: true,
        },
        mailTemplates: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'mailTemplate',
            displayField: 'machineName',
          },
          optional: true,
          form: false,
          view: true,
        },
        'mailTemplates.$': {
          type: String,
          optional: true,
        },
        mailLayouts: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'mailLayout',
            displayField: 'name',
          },
          optional: true,
          form: false,
          view: true,
        },
        'mailLayouts.$': {
          type: String,
          optional: true,
        },
        missingContents: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'missingContent',
            displayField: 'machineName',
          },
          optional: true,
          form: false,
          view: true,
        },
        'missingContents.$': {
          type: String,
          optional: true,
        },
        authorizationCodes: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'authorizationCode',
            displayField: 'id',
          },
          optional: true,
          form: false,
          view: false,
        },
        'authorizationCodes.$': {
          type: String,
          optional: true,
        },
        tenantUsers: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'tenantUser',
            displayField: 'email',
          },
          optional: true,
          form: false,
          view: true,
        },
        'tenantUsers.$': {
          type: String,
          optional: true,
        },
});

const { t } = getI18n();
schema.labels({
        id: t(['entityFields:tenant.id', 'entityFields:default.id'], '') || undefined,
        name: t(['entityFields:tenant.name', 'entityFields:default.name'], '') || undefined,
        timeZone: t(['entityFields:tenant.time_zone', 'entityFields:default.time_zone'], '') || undefined,
        userTenantRoles: t(['entityFields:tenant.user_tenant_role', 'entityFields:default.user_tenant_role'], '') || undefined,
        publicKey: t(['entityFields:tenant.public_key', 'entityFields:default.public_key'], '') || undefined,
        privateKey: t(['entityFields:tenant.private_key', 'entityFields:default.private_key'], '') || undefined,
        redirectUri: t(['entityFields:tenant.redirect_uri', 'entityFields:default.redirect_uri'], '') || undefined,
        termsAndConditions: t(['entityFields:tenant.terms_and_conditions', 'entityFields:default.terms_and_conditions'], '') || undefined,
        frontendBaseUri: t(['entityFields:tenant.frontend_base_uri', 'entityFields:default.frontend_base_uri'], '') || undefined,
        googleAuthEnabled: t(['entityFields:tenant.google_auth_enabled', 'entityFields:default.google_auth_enabled'], '') || undefined,
        googleId: t(['entityFields:tenant.google_id', 'entityFields:default.google_id'], '') || undefined,
        googleSecret: t(['entityFields:tenant.google_secret', 'entityFields:default.google_secret'], '') || undefined,
        microsoftAuthEnabled: t(['entityFields:tenant.microsoft_auth_enabled', 'entityFields:default.microsoft_auth_enabled'], '') || undefined,
        microsoftId: t(['entityFields:tenant.microsoft_id', 'entityFields:default.microsoft_id'], '') || undefined,
        microsoftSecret: t(['entityFields:tenant.microsoft_secret', 'entityFields:default.microsoft_secret'], '') || undefined,
        microsoftTenantId: t(['entityFields:tenant.microsoft_tenant_id', 'entityFields:default.microsoft_tenant_id'], '') || undefined,
        inviteExpiration: t(['entityFields:tenant.invite_expiration', 'entityFields:default.invite_expiration'], '') || undefined,
        passwordResetExpiration: t(['entityFields:tenant.password_reset_expiration', 'entityFields:default.password_reset_expiration'], '') || undefined,
        registerEnabled: t(['entityFields:tenant.register_enabled', 'entityFields:default.register_enabled'], '') || undefined,
        confirmAccountEnabled: t(['entityFields:tenant.confirm_account_enabled', 'entityFields:default.confirm_account_enabled'], '') || undefined,
        contents: t(['entityFields:tenant.content', 'entityFields:default.content'], '') || undefined,
        allowedApiHostnames: t(['entityFields:tenant.allowed_api_hostname', 'entityFields:default.allowed_api_hostname'], '') || undefined,
        mailTemplates: t(['entityFields:tenant.mail_template', 'entityFields:default.mail_template'], '') || undefined,
        mailLayouts: t(['entityFields:tenant.mail_layout', 'entityFields:default.mail_layout'], '') || undefined,
        missingContents: t(['entityFields:tenant.missing_content', 'entityFields:default.missing_content'], '') || undefined,
        authorizationCodes: t(['entityFields:tenant.authorization_code', 'entityFields:default.authorization_code'], '') || undefined,
        tenantUsers: t(['entityFields:tenant.tenant_user', 'entityFields:default.tenant_user'], '') || undefined,
});

export default schema;